export default function AddIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 16H24" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M16 24V8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
